<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  [resizable]="false"
  [closable]="true"
  [draggableDialog]="dialog"
  (onHide)="closeDialog()"
  [modal]="true"
  styleClass="bfx-dialog-warning"
>
  <p-header> {{title}} </p-header>
  <div>
    <p *ngFor="let msg of messages; let i = index;" [title]="msg">{{msg}}</p>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <div
      [hidden]="!data.dialogData.checkbox_show"
      style="width: 100%; text-align: left; padding-left: 6px"
    >
      <p-checkbox
        name="stp"
        value="stp"
        class="order__dialog__quick-fill-confirm__checkbox"
        [ngClass]="{
          'order__dialog__quick-fill-confirm__checkbox-label--disabled': data.dialogData.checkbox_disabled, 
          'order__dialog__quick-fill-confirm__checkbox-label--enabled': !data.dialogData.checkbox_disabled}"
        binary="true"
        [disabled]="data.dialogData.checkbox_disabled"
        [label]="data.dialogData.checkbox_text"
        [(ngModel)]="data.dialogData.checkbox_state"
        (onChange)="onChangeQuickFillConfirm_checkbox()"
      ></p-checkbox>
    </div>
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="closeDialog()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionConfirmed()"
      label="Fill"
    ></button>
  </p-footer>
</p-dialog>
